// js
import React from 'react';
import PropTypes from 'prop-types';
import { isString, trim } from 'lodash';
import { RIEInput } from 'riek';
import * as dsaTypes from '../constants/dsaTypes';
// css
import '../styles/components/InlineDSATitleInput.scss';


const defaultDSATitle = 'Untitled DSA';

const InlineDSATitleInput = ({ dsa, onChange, children }) => {
  const validator = val => isString(val) && !!trim(val).length > 0;
  const prefix = {
    [dsaTypes.NEW_CUSTOMER_DSA]: 'New Customer DSA',
    [dsaTypes.FULL_DSA]: 'DSA'
  }[dsa.type];
  // const EditIcon = Icons.IconEditGray;

  return (
    <div className='inline-dsa-title-input'>
      <span className='assessment-type'>{prefix}:&nbsp;</span>
      <RIEInput
        propName='name'
        className='assessment-title'
        value={dsa.name || defaultDSATitle}
        validate={validator}
        change={onChange}
        editProps={{
          maxLength: 220
        }}
      />&nbsp;
      {children}
    </div>
  );
};

InlineDSATitleInput.propTypes = {
  dsa: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  children: PropTypes.element
};

export default InlineDSATitleInput;



// WEBPACK FOOTER //
// ./src/components/InlineDSATitleInput.js